import tabs from "tabs";

class CollectionTabs {
  constructor() {
    this.tabsInit();
  }

  tabsInit() {
    const container = document.querySelector('.tab-container')

    if (container) {
      tabs(container);
    }
  }
}

export default CollectionTabs;